export default __webpack_public_path__ + "images/43_1_image.jpg";